import { Link } from "react-router-dom";
import WhatsAppLogo from "@/assets/whatsapp.png";

const WHATSAPP_CLAIM_URL =
  "https://wa.me/919324095283?text=Hi%2C%20I%20want%20to%20raise%20a%20request";

export default function ClaimsHowItWorks() {
  return (
    // phone image only shows on md+, so the tall min-height is md+ too
    <section className="tw-py-10 tw-text-black tw-relative tw-bg-[#EDEDED] md:tw-min-h-[90vh] tw-overflow-hidden">
      <img
        src="/izicart/HowItWorks.png"
        alt="Claims Process on Phone"
        className="tw-absolute lg:tw-h-[90%] lg:tw-top-5 lg:tw-right-20 tw--right-10 lg:tw-w-8/12 tw-object-top tw-object-cover tw-hidden md:tw-block"
      />

      <div className="tw-relative md:tw-w-4/5 tw-mx-auto">
        <h2 className="tw-text-4xl md:tw-text-5xl tw-text-center tw-mb-8 md:tw-mb-10 tw-font-semibold">
          How it works
        </h2>

        <div className="md:tw-w-2/5 md:tw-px-0 tw-px-6 tw-flex tw-flex-col tw-gap-5 tw-items-start">
          <h3 className="tw-text-3xl tw-font-semibold">
            Easy claims, great service
          </h3>

          {/* line breaks follow the design on xl+; text wraps freely below */}
          <p className="tw-text-lg tw-leading-relaxed xl:[&>span]:tw-block xl:[&>span]:tw-whitespace-nowrap">
            <span>Filing a claim is simple. Share a few details about what </span>
            <span>happened, and our team will review your claim and </span>
            <span>email you the details of your next steps.</span>
          </p>

          <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3 md:tw-gap-4">
            <Link
              to="/customer-login"
              className="tw-rounded-full tw-border tw-border-black tw-px-6 tw-py-3 tw-text-black tw-no-underline hover:tw-bg-black hover:tw-text-white tw-transition-colors"
            >
              Start a Claim
            </Link>

            <a
              href={WHATSAPP_CLAIM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-border tw-border-black tw-px-5 md:tw-px-6 tw-py-3 tw-text-black tw-no-underline hover:tw-bg-black hover:tw-text-white tw-transition-colors"
            >
              <img
                src={WhatsAppLogo}
                alt="WhatsApp"
                width={20}
                height={20}
                className="tw-h-5 tw-w-5 tw-shrink-0 tw-object-contain"
              />
              Quick Claim
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
